<template>
	<svg
		width="15px"
		height="12px"
		viewBox="0 0 15 12"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="leave meeting icon"
	>
		<g
			id="Meetings"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Group-15"
				transform="translate(-132.000000, -123.000000)"
				fill="#4F4F4F"
				fill-rule="nonzero"
			>
				<g id="Group-7" transform="translate(58.000000, 109.000000)">
					<g id="Group-5" transform="translate(74.000000, 10.000000)">
						<path
							d="M7.52284528,12.0574521 C7.97403946,12.0574521 8.32242991,11.6786012 8.32242991,11.2472939 L8.32242991,5.7743547 L8.24818276,4.93505412 L8.49376947,5.41881765 L9.07061267,6.04246461 C9.201973,6.18234804 9.37902388,6.26977519 9.57892004,6.26977519 C9.92159917,6.26977519 10.258567,5.9958368 10.258567,5.60532889 C10.258567,5.40133222 10.1843198,5.26144879 10.0529595,5.12739384 L8.17393562,3.29142381 C7.96261682,3.07577019 7.73987539,3 7.52284528,3 C7.30581516,3 7.08307373,3.07577019 6.87175493,3.29142381 L4.99273105,5.12739384 C4.86137072,5.26144879 4.78712357,5.40133222 4.78712357,5.60532889 C4.78712357,5.9958368 5.12409138,6.26977519 5.46105919,6.26977519 C5.66666667,6.26977519 5.84371755,6.18234804 5.97507788,6.04246461 L6.54620976,5.41881765 L6.79179647,4.93505412 L6.72326064,5.7743547 L6.72326064,11.2472939 C6.72326064,11.6786012 7.07165109,12.0574521 7.52284528,12.0574521 Z M10.8296989,17 C12.2061267,17 13,16.1956703 13,14.7910075 L13,9.34138218 C13,7.9367194 12.2061267,7.13238968 10.8296989,7.13238968 L9.44755971,7.13238968 L9.44755971,9.02081599 L10.5669782,9.02081599 C10.9496366,9.02081599 11.1438214,9.19567027 11.1438214,9.62114904 L11.1438214,14.5170691 C11.1438214,14.9367194 10.9496366,15.1115737 10.5669782,15.1115737 L4.43302181,15.1115737 C4.04465213,15.1115737 3.85046729,14.9367194 3.85046729,14.5170691 L3.85046729,9.62114904 C3.85046729,9.19567027 4.04465213,9.02081599 4.43302181,9.02081599 L5.59813084,9.02081599 L5.59813084,7.13238968 L4.17030114,7.13238968 C2.79387331,7.13238968 2,7.9367194 2,9.34138218 L2,14.7910075 C2,16.1956703 2.79387331,17 4.17030114,17 L10.8296989,17 Z"
							id="Leave-icon"
							transform="translate(7.500000, 10.000000) rotate(-270.000000) translate(-7.500000, -10.000000) "
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	Name: 'LeaveMeeting',
}
</script>
<style lang="scss" scoped>
svg {
	&.danger {
		g {
			fill: #ffffff;
		}
	}
}
</style>
